import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { twMerge } from 'tailwind-merge'

export type ButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants>

const buttonVariants = cva('button', {
  variants: {
    variant: {
      default: 'button-secondary',
      cta: 'button-primary',
      floating: 'button-floating',
      text: 'button-text !bg-inherit',
      ghost: 'button-ghost',
      nav: 'focus bg-white hover:bg-gray-10',
      listItem: 'bg-white hover:bg-gray-10 w-full flex justify-between',
      icon: 'button-icon text-button-tertiary',
      rounded:
        'focus !py-1.5 inline-flex gap-1.5 rounded-3xl border-2 bg-white text-black border-gray hover:border-border-interactive hover:bg-highlight',
      'rounded-filled':
        'focus !py-1.5 inline-flex gap-1.5 rounded-3xl border-2 bg-black text-white border-black hover:border-border-interactive hover:bg-highlight hover:text-black',
      outline: 'button-outline',
    },
    size: {
      default: '',
      medium: 'button-medium',
      xl: 'button-xl',
      md: 'button-md',
      sm: 'button-sm',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})

function Button({
  className,
  variant,
  size,
  type = 'submit',
  ...props
}: ButtonProps) {
  return (
    <ButtonPrimitive
      data-slot="button"
      type={type}
      className={twMerge(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
